import React, { useState } from "react";
import "./Expenses.css";
import CustomDropdown from "../../../../../Components/CustomDropdown/CustomDropdown";
import CustomTimeSelector from "../../../../Components/CustomTimeSelector/CustomTimeSelector";
import CustomTable from "../../../../Components/CustomTable/CustomTable";
import CustomSwitch from "../../../../../Components/CustomSwitch/CustomSwitch";
import { Checkbox, FormControlLabel, Radio, RadioGroup } from "@mui/material";

const initialExpensesData = [
  {
    id: 1,
    title: "Any amounts paid for to doctors, dentists, hospitals",
    status: false,
  },
  {
    id: 2,
    title:
      "Did you make any charitable contributions? If yes, please give details.",
    status: false,
  },
  {
    id: 3,
    title:
      "Do you have a Home Mortgage Interest in US or India? If yes, please give details.",
    status: true,
  },
  {
    id: 4,
    title: "Any casualty or theft losses? If yes, please give details",
    status: false,
  },
  {
    id: 5,
    title: "Have you paid alimony in 2020? If yes please specify the amount",
    status: false,
  },
  {
    id: 6,
    title:
      "Did you itemize your returns last year? if yes please provide state refund",
    status: false,
  },
  {
    id: 7,
    title:
      "Did you pay any Sales and Excise taxes on vehicle bought in 2020. If yes please upload bills",
    status: false,
  },
  {
    id: 8,
    title:
      "If you are resident of MA State, NJ State, CA State IN State, WI State? Provide Per month rent you are paying.",
    status: false,
  },
  {
    id: 9,
    title:
      "If you are resident of MA State? Are you and your family covered with MA health insurance? If yes, mention the no. of months covered..",
    status: false,
  },
  {
    id: 10,
    title:
      "If you are resident of OH & PA for 2020? If yes please provide your Home and Work address",
    status: false,
  },
];
const initialContributionData = [
  {
    id: 1,
    title:
      "Do you make any additional contributions to H.S.A/ Apart from you we?",
    status: false,
  },
  {
    id: 2,
    title:
      "Do you make any additional contributions to I.R.A/401k plan Apart from you we?",
    status: false,
  },
  {
    id: 3,
    title: "Do you have student loan? If yes, please upload document 1098E",
    status: true,
  },
  {
    id: 4,
    title:
      "Did you pay any tuition fee for self, spouse or dependents? If yes, please upload document 1098T.",
    status: false,
  },
  {
    id: 5,
    title: "Is your health insurance covered from employer or market place.?.",
    status: false,
  },
  {
    id: 6,
    title:
      "Form 1095-A if you enrolled in an insurance plan through the Marketplace",
    status: false,
  },
  {
    id: 7,
    title:
      "Did you purchase any energy saving product in USA? If yes please specify it.",
    status: false,
  },
  {
    id: 8,
    title: "Have you purchased any Hybrid motor Vehicle in the TY 2020?",
    status: false,
  },
];

const Expenses = () => {
  const [expensesData, setExpensesData] = useState(initialExpensesData);
  const [contributionData, setContributionData] = useState(
    initialContributionData
  );
  const handleExpensesTabStatus = (id, status) => {
    const updatedData = [...expensesData];

    const index = updatedData.findIndex((item) => item.id === id);
    if (index !== -1) {
      updatedData[index] = {
        ...updatedData[index],
        status: status,
      };
      setExpensesData(updatedData);
    }
  };
  const handleContributionTabStatus = (id, status) => {
    const updatedData = [...contributionData];

    const index = updatedData.findIndex((item) => item.id === id);
    if (index !== -1) {
      updatedData[index] = {
        ...updatedData[index],
        status: status,
      };
      setContributionData(updatedData);
    }
  };
  return (
    <div className="cltdetails__expenses_page">
      <div className="cltdetails__expenses_contentwrap">
        <div className="cltdetails__expenses_contentbox">
          <div
            className="cltdetails__expenses_cboxheader"
            style={{ background: "rgba(5, 89, 91, 0.75)" }}
          >
            Expenses
          </div>
          <div className="cltdetails__expenses_cboxbody">
            <div className="cltdetails__expenses_cboxrow">
              {expensesData?.map((tab) => (
                <div className="cltdetails__expenses_questiontab">
                  <div className="cltdetails__expenses_qtabcontent">
                    <div className="cltdetails__expenses_qtableft">
                      {tab.title}
                    </div>
                    <div className="cltdetails__expenses_qtabright">
                      <span>{tab.status ? "YES" : "NO"}</span>{" "}
                      <CustomSwitch
                        onSwitch={(active) => {
                          handleExpensesTabStatus(tab.id, active);
                        }}
                        color="rgba(5, 89, 91, 0.75)"
                        defaultChecked={tab.status}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="cltdetails__expenses_contentbox">
          <div
            className="cltdetails__expenses_cboxheader"
            style={{ background: "rgba(167, 141, 254, 1)" }}
          >
            Contribution
          </div>
          <div className="cltdetails__expenses_cboxbody">
            <div className="cltdetails__expenses_cboxrow">
              {contributionData?.map((tab) => (
                <div className="cltdetails__expenses_questiontab">
                  <div className="cltdetails__expenses_qtabcontent">
                    <div className="cltdetails__expenses_qtableft">
                      {tab.title}
                    </div>
                    <div className="cltdetails__expenses_qtabright">
                      <span>{tab.status ? "YES" : "NO"}</span>{" "}
                      <CustomSwitch
                        onSwitch={(active) => {
                          handleContributionTabStatus(tab.id, active);
                        }}
                        color="rgba(167, 141, 254, 1)"
                        defaultChecked={tab.status}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div
          className="cltdetails__expenses_checkboxitm2"
          style={{ border: "none" }}
        >
          <div className="cltdetails__expenses_cbicbox">
            {" "}
            <Checkbox
              defaultChecked
              sx={{
                "&.Mui-checked": {
                  color: "rgba(29, 66, 102, 1)",
                },
              }}
            />
          </div>
          <div className="cltdetails__expenses_cbirttxt">
            I declare that the information in this application is true and
            correct
          </div>
        </div>
        <div className="cltdetails__expenses_savebtnwrap">
          <button className="cltdetails__expenses_savebtn">Save</button>
        </div>
      </div>
      <div className="cltdetails__expenses_contentwrap">
        <div className="cltdetails__expenses_bottombtns">
          <button className="cltdetails__expenses_bbtnfilled">Submit</button>
          <button className="cltdetails__expenses_bbtnoutlined">Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default Expenses;
